/**
 * RESPONSIBILITY: the hyphenated form of a title.
 *
 * Here rather than beside the components that link to things, because the SERVER needs
 * it too — an event's address is worked out when the event is saved, and `app/web` is
 * browser code the server must never import. A second copy under `app/web` was the
 * alternative, and a value with two derivations has no derivation.
 */

/**
 * Lowercase, unaccented, hyphenated. Apostrophes are DROPPED rather than turned into a
 * separator, so "Men's" is `mens` and not `men-s`.
 */
export const slugify = (s: string): string =>
  s.normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/['\u2018\u2019]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
